<template>
    <div class="container">
        <div>
            <setor-search/>
            <setor-create/>
            <setor-update/>
            <setor-delete/>
        </div>
        <div class="row remove-padding-left-right-grid">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card card-border-top">
                    <div class="card-body">
                        <h4 class="card-title">Setores</h4>
                        <p class="card-description text-right"> 
                            <button @click="initSearch()" type="button" class="btn btn-outline-primary">
                                <i class="mdi mdi-filter"></i>
                                {{ titleButtonFilter }}
                            </button>
                            <button @click="initAdd()"  type="button" class="btn btn-outline-primary">
                                <i class="mdi mdi-plus-circle"></i>Novo
                            </button>
                        </p>
                        <div class="table-responsive" style="min-height: 60vh;">
                            <table class="table table-hover">
                                <thead>
                                    <tr class="d-flex">
                                        <th :style="columns.one"> # </th>
                                        <th :style="columns.two"> Nome/ Responsável</th>
                                        <!-- <th class="col-2"> Responsável </th> -->
                                        <th :style="columns.three"> Unidade </th>
                                        <th :style="columns.four"> Ações </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="d-flex" v-for="(item, index) in setores">
                                        <td :style="columns.one" class="vertical-center-middle">
                                            {{ index + 1 }}
                                        </td>
                                        <td :style="columns.two"> 
                                            {{ item.nome }} / <br/>
                                            {{ item.responsavel }} 
                                        </td>
                                        <!-- <td> 
                                            {{ item.responsavel }} 
                                        </td> -->
                                        <td :style="columns.three" class="vertical-center-middle"> 
                                            {{ item.unidade_nome }} 
                                        </td>
                                        <td :style="columns.four" class="vertical-center-middle">
                                            <div class="dropdown">
                                                <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-outline-primary">
                                                    <i class="mdi mdi-format-list-bulleted"></i>
                                                </button>
                                                
                                                <div class="dropdown-menu" 
                                                    x-placement="top-start" >
                                                    <a @click="initUpdate(item)" class="dropdown-item">
                                                        Editar
                                                    </a>
                                                    <div class="dropdown-divider"></div>
                                                    <a @click="initDelete(item)" class="dropdown-item">
                                                        Deletar
                                                    </a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="setores.length == 0">
                                        <td colspan="5" class="text-center">
                                            Nenhum item encontrado.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="mt-3">
                            <pagination :paginationData="pagination" @navigate="goToPage"></pagination>
                        </div>

                    </div>
                </div>
            </div>
        </div>
      
    </div>
</template>

<style type="text/css" scoped>
    .card-title {
        margin-bottom: 0px !important;
        font-size: 18px !important;
        padding-top: 16px !important;
        padding-left: 10px !important;
    }
    .card-description {
        margin-bottom: 8px !important;
    }
    .card-border-top {
        border-top: 3px solid #149AF9 !important;
    }
    .card-body {
        padding: 0px 10px !important;
    }
    .btn {
        padding: 7px 7px !important;
    }
    .vertical-center-middle {
        white-space:normal;
        text-align: justify;
        display: flex;
        align-items: center;
    }
    table tbody tr td{
        font-size: 13px;
    }
</style>

<script>

    import moment from 'moment';
    import { eventBus } from '../../app';
    import Pagination from '../paginacao/Pagination.vue';

    export default {

        components: {
            Pagination
        },

        data(){
            return {
                columns: {
                    one: 'width: 3%;',
                    two: 'width: 48%;',
                    three: 'width: 43%;',
                    four: 'width: 5%;'
                },
                titleButtonFilter: 'Filtrar',
                
                isLoading: false,
                //ARRAYS
                setores: [],

                //SEARCH DATA
                filtros: [],

                //PAGINATION
                pagination: {}
            }
        },

        mounted() {
            this.registryEvents();
            this.getSetores();
        },

        filters: {
            formatDataBr: function (date) {
                if (date) {
                    return moment(date).format('DD/MM/YYYY');
                }
                return '-';
            }
        },

        methods: {
            //REGISTRY EVENTS
            registryEvents(){
                this.registryEventGetSetores();
                this.registryEventGetSetoresFilter();
            },
            registryEventGetSetores(){
                eventBus.$on('eventGetSetores', (page) => {
                    this.getSetores(page);
                });
            },
            registryEventGetSetoresFilter(){
                eventBus.$on('eventGetSetoresFilter', (filtrosEvent) => {
                    this.filtros = filtrosEvent;
                    this.setTitleFilterButton();
                    this.getSetores();
                });
            },
            //FIM REGISTRY EVENTS

            emitEventOpenModalSearch(){
                eventBus.$emit('eventOpenModalSearchSetor', this.filtros);
            },
            emitEventOpenModalCreate(){
                eventBus.$emit('eventOpenModalCreateSetor');
            },
            emitEventOpenModalUpdate(item){
                eventBus.$emit('eventOpenModalUpdateSetor', 
                    item,
                    this.pagination.current_page
                );
            },
            emitEventOpenModalDelete(item){
                eventBus.$emit('eventOpenModalDeleteSetor', 
                    item,
                    this.pagination.current_page
                );
            },

            initSearch(){
                this.emitEventOpenModalSearch();
            },
            initAdd()
            {
                this.emitEventOpenModalCreate();
            }, 
            initUpdate(item)
            {
                this.emitEventOpenModalUpdate(item);
            },
            initDelete(item)
            {
                this.emitEventOpenModalDelete(item);
            },

            getSetores(page)
            {
                var urlSetores = '/setor/listdata';

                this.isLoading = true;

                this.setores = [];

                axios({
                    method: 'GET',
                    url: urlSetores,
                    params: {
                        filters: this.filtros,
                        page: page //UTILIZADO NA PAGINAÇÃO
                    }
                })
                .then(response => {
                    this.setores = response.data.setores.data;
                    this.pagination = response.data.pagination;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao atualizar a pagina');
                });
            },
            goToPage: function (page)
            {
                this.pagination.current_page = page;
                this.getSetores(page);
            },
            setTitleFilterButton(){
                if(this.filtros.length > 0){
                    var textFilter = this.filtros.length > 1 ? 'Filtros' : 'Filtro';
                    this.titleButtonFilter = '('+this.filtros.length+') '+textFilter;
                }
                else {
                    this.titleButtonFilter = 'Filtrar'; 
                }
            },
        }
    }
</script>
